import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const getItemNonCatalog = async (id) => {
  	var response = await axios
    	.get(process.env.REACT_APP_API_URL + "/admin/allcatalog/item/" + id, { headers: AuthHeader.authHeader() });
		console.log("Get NC Item", response.data);
		for(var i=0; i<response.data.item.length; i++) {
			response.data.item[i].sizes = JSON.parse(response.data.item[i].sizes);
			response.data.item[i].sizes.sort(function compareFn(a, b) {
			if (a.order < b.order ) {
				return -1;
			}
			if (a.order > b.order) {
				return 1;
			}
			// a must be equal to b
			return 0;
			});
	  	}
console.log("Decos", response.data.decorations);
	    return {item: response.data.item, decorations: response.data.decorations, quantityPrices: response.data.quantityPrices || []};
};


const ItemService = {
    getItemNonCatalog
};
export default ItemService;